export default {
    "app.header": "Voyager Translation Services",
    "about.header": "About Voyager",
    "services.header": "Services we offer",
    "prices.header": "Pricing"
};